goog.provide("shadow.js.shim.module$$mui$icons_material$CheckCircleRounded$default");
shadow.js.shim.module$$mui$icons_material$CheckCircleRounded$default = shadow.js.shim.module$$mui$icons_material$CheckCircleRounded.default;
